import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import WPTypography from "../../packages/WPTypography/WPTypography";
import { CleaningAdvisorLogo } from "../../assets/icons";
import { FOOTER_LINKS, SOCIAL_MEDIA_LINKS } from "./Footer.constants";
import "./Footer.scss";
const FooterLink = ({ href, text, noreferrer, dataTestId }) => (
  <>
    <a
      href={href}
      data-test-id={dataTestId}
      className="footer-link"
      target="__blank"
      rel={`noopener${noreferrer ? " noreferrer" : ""}`}
    >
      {text}
    </a>
  </>
);
const Footer = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const appVersion = process.env.REACT_APP_RELEASE_VERSION;
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  return (
    <>
      <div id="footer-container" className="footer-wrapper">
        <div className="app-max-width d-flex mx-auto">
          <div className="footer-left-content">
            <div className="footer-links-wrapper">
              {FOOTER_LINKS(t, language).map((link, index) => (
                <React.Fragment key={index}>
                  <FooterLink href={link.href} text={link.text} />
                  <div className="vertical-line"></div>
                </React.Fragment>
              ))}
              <a id="teconsent"></a>
            </div>
            <WPTypography
              className="copy-right-text"
              text={t("footer.footerCopyright", { currentYear: currentYear })}
            />
            <div className="social-icons">
              {SOCIAL_MEDIA_LINKS.map((social, index) => (
                <FooterLink
                  dataTestId={social.id}
                  key={index}
                  href={social.href}
                  text={<social.Icon />}
                  noreferrer
                />
              ))}
            </div>
          </div>
          <div className="footer-right-content">
            <div className="text-end">
              <WPTypography
                className="wave-engine-text"
                asElement="h6"
                text={t("footer.reverseOsmosisOpsAdvisor")}
              />
              <WPTypography
                className="dupont-solutions-text"
                text={t("footer.dupontWaterSolutions")}
              />
              {appVersion && (
                <WPTypography
                  className="version-text"
                  text={t("footer.version") + appVersion}
                />
              )}
            </div>
            <div className="margin-left-10">
              <CleaningAdvisorLogo fill="white" width="60" height="60" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
